import type { components } from "../../generated/api.js";

/**
 * Laufzeit-Konfiguration der Oberfläche.
 *
 * Sie kommt vom Backend (`GET /api/config`), nicht aus Bauzeit-Variablen: dasselbe
 * Image soll bei jedem Kunden unter dessen Domain laufen, ohne neu gebaut zu werden.
 * Nur die Adresse der API selbst steht fest — sie liegt immer unter derselben Herkunft.
 */
export type RuntimeConfig = components["schemas"]["RuntimeConfigDTO"];

export interface FrontendConfig extends RuntimeConfig {
  apiBaseUrl: string;
}

const API_BASE_URL = "/api";

let loaded: FrontendConfig | null = null;

/** Einmal beim Start geladen, bevor irgendetwas gezeichnet wird. */
export async function loadFrontendConfig(): Promise<FrontendConfig> {
  const response = await fetch(`${API_BASE_URL}/config`, {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error(`Die Server-Konfiguration ist nicht erreichbar (HTTP ${response.status}).`);
  }
  loaded = { ...((await response.json()) as RuntimeConfig), apiBaseUrl: API_BASE_URL };
  return loaded;
}

export function frontendConfig(): FrontendConfig {
  if (!loaded) {
    throw new Error("Die Konfiguration wurde noch nicht geladen.");
  }
  return loaded;
}

/** Nur für Tests. */
export function setFrontendConfig(config: FrontendConfig | null): void {
  loaded = config;
}

export { API_BASE_URL };
